import Styles from "./whatGPT3.module.css";

function WhatGPT3() {
    return (
        <section className={Styles.container}>
            <div className={Styles.title}>
                <h3>What is GPT-3</h3>
                <p>
                    We so opinion friends me message as delight. Whole front do of plate heard oh ought. His defective nor convinced residence own. Connection has put impossible own apartments boisterous. At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by.
                </p>
            </div>
            <div className={Styles.middle}>
                <h2>The possibilities are beyond your imagination</h2>
                <p>Explore The Library</p>
            </div>
            <div className={Styles.box}>
                <div>
                    <h3>Chatbots</h3>
                    <p>
                        We so opinion friends me message as delight. Whole front do of plate heard oh ought.
                    </p>
                </div>

                <div>
                    <h3>Knowledgebase</h3>
                    <p>
                        At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b
                    </p>
                </div>

                <div>
                    <h3>Education</h3>
                    <p>
                        At jointure ladyship an insisted so humanity he. Friendly bachelor entrance to on by. As put impossible own apartments b
                    </p>
                </div>
            </div>

        </section>
    )
}

export default WhatGPT3